import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from './pages/HomePage';
import axios from "axios";
import constants from './constants';
import "bootstrap/dist/css/bootstrap.min.css";
import PreviewPage from './pages/PreviewPage';

axios.defaults.baseURL = constants.DEFAULT_URL;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:type" element={<HomePage />} />
        <Route path="/:type/preview" element={<PreviewPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
